import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { showLoginModal, login } from "../../actions/GalleryActions";
import Cancel from "../../assets/images/cancel.svg";
import Loading from "../../assets/images/loading.gif";

function LoginModal() {
  const [ t ] = useTranslation();

  const dispatch = useDispatch();
  const user = useSelector(({ Gallery }) => Gallery?.user);

  const [type, setType] = useState("consultant")
  const [email, setEmail] = useState()
  const [pass, setPass] = useState()
  const [error, setError] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [showError, setShowError] = useState(false)
  const [loadingRequest, setLoadingRequest] = useState(false)
  
  const signin = useCallback(async() => {
      try {
        setLoadingRequest(true)
        await dispatch(login(type, email, pass))
      } catch (error) {
        const message = (error.message === 'ACCOUNT_LOCKED') ? t('auth.account_locked') : t('auth.login_error')
        setErrorMessage(message)
        setShowError(true)
      } finally {
        setLoadingRequest(false)
      }
    },
    [dispatch, type, email, pass],
  )
  
  useEffect(() => {
    setError(user.message)
  }, [user])

  return (
    <div className="signin-modal">
      <div className="overlay"></div>
      <div className="modal-content">
        <div className="head">
          <p>{t('auth.login')}</p>
          <img className="close-modal" src={Cancel} alt="" onClick={() => {
            setShowError(false)
            dispatch(showLoginModal(false))
          }} />
        </div>
        <div className="usertype-select">
          <p>{t('auth.login_as')}</p>
          <div className={"btn " + (type === "consultant" ? "active" : "")} onClick={() => setType("consultant")}>{t('auth.consultant')}</div>
          <div className={"btn " + (type === "client" ? "active" : "")} onClick={() => setType("client")}>{t('auth.client')}</div>
        </div>
        <div className="input-holder">
          <p className="label">{t('auth.email')}</p>
          <input className="email-inp" type="text" onChange={e => setEmail(e.target.value)} />
        </div>
        <div className="input-holder">
          <p className="label">{t('auth.password')}</p>
          <input className="pass-inp" type="password" onChange={e => setPass(e.target.value)} />
        </div>
        <p className="login-error">{showError ? errorMessage : ""}</p>
        <div className={"login-btn " + (loadingRequest ? "disabled" : "")} onClick={signin}>
          {
            loadingRequest ?
            <div className="loading">
              <img src={Loading} alt="" />
            </div>
            :
            t('auth.login')
          }
        </div>
      </div>
    </div>
  );
}

export default LoginModal